/* Modèle pour transférer les logos */
export class Logo {
    logoPersonnalise: string;
    logoSecondaire: string;
    randomImage: string;
}

/**
 * Énumération des types de logos
 */
export enum TypeLogo {
    /** Logo Notilus par défaut */
    LOGO_NOTILUS = 'logoNotilus',
    /** Logo personnalisé */
    LOGO_PERSONNALISE = 'logoPersonnalise',
    /** Aucun logo */
    AUCUN_LOGO = 'aucunLogo'
}

/**
 * Interface pour les options de logo
 */
export interface LogoOption {
    /** Valeur de l'option */
    value: TypeLogo;
    /** Libellé de l'option */
    libelle: string;
}